import React, { useState } from "react";
import {
    Box,
    Grid,
    Container,
    Modal,
    IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const ImageMontage = ({ images, type = "square" }) => {
    const [open, setOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);

    const handleOpen = (index) => {
        setCurrentIndex(index);
        setOpen(true);
    };

    const handleClose = () => setOpen(false);

    const handlePrev = (e) => {
        e.stopPropagation();
        setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
    };

    const handleNext = (e) => {
        e.stopPropagation();
        setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    };

    return (
        <>
            {/* --- MONTAGE GRID --- */}
            <Container maxWidth="lg" sx={{ mt: 10 }}>
                <Grid container spacing={2} justifyContent="center">
                    {images.map((src, index) => (
                        <Grid item xs={type === "square" ? 6 : 12} sm={type === "square" ? 4 : 6} md={type === "square" ? 2.4 : 4} key={index}>
                            <Box
                                onClick={() => handleOpen(index)}
                                sx={{
                                    position: "relative",
                                    overflow: "hidden",
                                    borderRadius: type === "square" ? 2 : 3,
                                    aspectRatio: type === "square" ? "1 / 1" : "auto",
                                    cursor: "pointer",
                                    "& img": {
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        transition: "transform 0.6s ease",
                                    },
                                    "&:hover img": { transform: "scale(1.1)" },
                                }}
                            >
                                <img src={require(`${src}`)} alt={`Montage ${index + 1}`} />
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Container>

            {/* --- FULL-SIZE MODAL --- */}
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="image-modal"
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backdropFilter: "blur(4px)",
                    bgcolor: "rgba(0,0,0,0.8)",
                }}
            >
                <Box
                    sx={{
                        position: "relative",
                        outline: "none",
                        maxWidth: "90vw",
                        maxHeight: "90vh",
                        borderRadius: 2,
                        overflow: "hidden",
                    }}
                >
                    {/* CLOSE BUTTON */}
                    <IconButton
                        onClick={handleClose}
                        sx={{
                            position: "absolute",
                            top: 10,
                            right: 10,
                            color: "white",
                            bgcolor: "rgba(0,0,0,0.4)",
                            "&:hover": { bgcolor: "rgba(0,0,0,0.6)" },
                            zIndex: 5,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>

                    {/* PREV BUTTON */}
                    <IconButton
                        onClick={handlePrev}
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: 10,
                            transform: "translateY(-50%)",
                            color: "white",
                            bgcolor: "rgba(0,0,0,0.4)",
                            "&:hover": { bgcolor: "rgba(0,0,0,0.6)" },
                            zIndex: 5,
                        }}
                    >
                        <ArrowBackIosNewIcon />
                    </IconButton>

                    {/* NEXT BUTTON */}
                    <IconButton
                        onClick={handleNext}
                        sx={{
                            position: "absolute",
                            top: "50%",
                            right: 10,
                            transform: "translateY(-50%)",
                            color: "white",
                            bgcolor: "rgba(0,0,0,0.4)",
                            "&:hover": { bgcolor: "rgba(0,0,0,0.6)" },
                            zIndex: 5,
                        }}
                    >
                        <ArrowForwardIosIcon />
                    </IconButton>

                    {/* IMAGE DISPLAY */}
                    <img
                        src={require(`${images[currentIndex]}`)}
                        alt="Full size"
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                            display: "block",
                            maxWidth: "600px"
                        }}
                    />
                </Box>
            </Modal>
        </>
    );
};

export default ImageMontage;